import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft, Play, Video } from 'lucide-react';

const KidsVideosPage = () => {
  const navigate = useNavigate();
  const [playingVideo, setPlayingVideo] = useState(null);

  const videos = [
    {
      id: 1,
      title: "Animal Alphabet",
      description: "Learn the alphabet with fun animals! A is for Alligator, B is for Bear...",
      emoji: "🦁",
      color: "from-purple-400 to-pink-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/w7u8tays_Animal%20Alphabet.mp4",
      duration: "Educational"
    },
    {
      id: 2,
      title: "Birds",
      description: "Discover beautiful birds from around the world! Learn their names and sounds.",
      emoji: "🐦",
      color: "from-blue-400 to-cyan-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/aijlaubv_Birds.mp4",
      duration: "Educational"
    },
    {
      id: 3,
      title: "Farm Animals",
      description: "Meet the animals on the farm! Cows, pigs, chickens and more fun friends.",
      emoji: "🐄",
      color: "from-green-400 to-emerald-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/l23uw8wt_Farm%20Animals.mp4",
      duration: "Educational"
    },
    {
      id: 4,
      title: "Food",
      description: "Learn about yummy foods! Fruits, vegetables, and treats for growing kids.",
      emoji: "🍎",
      color: "from-orange-400 to-red-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/fbx03oz7_Food.mp4",
      duration: "Educational"
    },
    {
      id: 5,
      title: "Pets",
      description: "Meet adorable pets! Dogs, cats, and other furry friends we love.",
      emoji: "🐕",
      color: "from-amber-400 to-yellow-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/lyp7ymfa_Pet.mp4",
      duration: "Educational"
    },
    {
      id: 6,
      title: "Sea Animals",
      description: "Dive into the ocean! Meet dolphins, fish, whales and amazing sea creatures.",
      emoji: "🐬",
      color: "from-teal-400 to-blue-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/8530e6w7_Sea%20Animals.mp4",
      duration: "Educational"
    },
    {
      id: 7,
      title: "Vehicles",
      description: "Vroom vroom! Learn about cars, trucks, planes and things that go!",
      emoji: "🚗",
      color: "from-red-400 to-rose-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/f9dzdo17_Vehicles.mp4",
      duration: "Educational"
    },
    {
      id: 8,
      title: "Planets",
      description: "Blast off to space! Explore planets, stars and our amazing solar system.",
      emoji: "🪐",
      color: "from-indigo-400 to-purple-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/mykbmeta_Planet.mp4",
      duration: "Educational"
    },
    {
      id: 9,
      title: "Vegetables",
      description: "Learn about healthy veggies! Carrots, broccoli, and garden favorites.",
      emoji: "🥕",
      color: "from-lime-400 to-green-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/r7cinxt6_Vegetable.mp4",
      duration: "Educational"
    },
    {
      id: 10,
      title: "Places",
      description: "Explore amazing places! Learn about parks, schools, stores and more.",
      emoji: "🏠",
      color: "from-sky-400 to-blue-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/khsc24kw_Place.mp4",
      duration: "Educational"
    },
    {
      id: 11,
      title: "Opposite Words",
      description: "Big and small, hot and cold! Learn fun opposite words together.",
      emoji: "🔄",
      color: "from-fuchsia-400 to-pink-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/menqz0lm_Opposite%20Word%20Learning.mp4",
      duration: "Educational"
    },
    {
      id: 12,
      title: "Jungle Animals",
      description: "Roar! Meet lions, monkeys, elephants and wild jungle friends.",
      emoji: "🦧",
      color: "from-emerald-400 to-teal-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/6h8so36n_Jungle%20Animals.mp4",
      duration: "Educational"
    },
    {
      id: 13,
      title: "Fruits",
      description: "Yummy fruits! Learn about apples, bananas, oranges and sweet treats.",
      emoji: "🍇",
      color: "from-violet-400 to-purple-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/1d4bb665_Fruit%20Learning.mp4",
      duration: "Educational"
    },
    {
      id: 14,
      title: "Flowers",
      description: "Beautiful flowers! Learn about roses, sunflowers and colorful blooms.",
      emoji: "🌸",
      color: "from-pink-400 to-rose-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/wyp1ra41_Flower.mp4",
      duration: "Educational"
    },
    {
      id: 15,
      title: "Colors",
      description: "Red, blue, yellow, green! Learn all the colors of the rainbow.",
      emoji: "🌈",
      color: "from-cyan-400 to-blue-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/8tqr8v72_Color.mp4",
      duration: "Educational"
    },
    {
      id: 16,
      title: "Body Parts",
      description: "Head, shoulders, knees and toes! Learn all about your body.",
      emoji: "🫀",
      color: "from-red-400 to-orange-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/qrit84t4_Body%20Parts.mp4",
      duration: "Educational"
    },
    {
      id: 17,
      title: "Baby",
      description: "Adorable babies! Learn about baby things and cute little ones.",
      emoji: "👶",
      color: "from-pink-300 to-purple-400",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/kzhhbano_Baby.mp4",
      duration: "Educational"
    },
    {
      id: 18,
      title: "Action Words",
      description: "Run, jump, clap, dance! Learn fun action words and move along.",
      emoji: "🏃",
      color: "from-orange-400 to-yellow-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/3n96hoi5_Action%20word.mp4",
      duration: "Educational"
    },
    {
      id: 19,
      title: "Relaxing Zen Music",
      description: "Calm and peaceful music for relaxation and stress relief. Perfect for quiet time!",
      emoji: "🧘",
      color: "from-teal-400 to-cyan-500",
      videoUrl: "https://customer-assets.emergentagent.com/job_braingame-17/artifacts/3rra9b4t_Relaxing%20Zen%20Music%20For%20Stress%20Relief.mp4",
      duration: "Relaxation"
    },
  ];

  return (
    <div className="min-h-screen p-4 md:p-8" style={{
      background: 'linear-gradient(135deg, #c084fc 0%, #f0abfc 100%)'
    }}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <Button
            onClick={() => navigate('/age-selection')}
            variant="ghost"
            className="text-lg font-semibold hover:scale-110 transition-transform bg-white/50 hover:bg-white/70"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back
          </Button>
        </div>

        {/* Title */}
        <div className="text-center mb-10">
          <div className="text-6xl mb-4">🎬</div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{
            textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
          }}>
            Kids Videos
          </h1>
          <p className="text-xl text-white/90">
            Watch and learn with fun educational videos!
          </p>
        </div>

        {/* Videos Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((video) => (
            <Card
              key={video.id}
              className="overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              style={{ borderRadius: '24px' }}
            >
              {/* Video Thumbnail / Player Area */}
              <div className={`relative h-56 bg-gradient-to-br ${video.color} flex items-center justify-center overflow-hidden`}>
                {playingVideo === video.id ? (
                  <video
                    className="absolute inset-0 w-full h-full object-cover"
                    controls
                    autoPlay
                    src={video.videoUrl}
                  >
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <>
                    <div className="absolute inset-0 opacity-20">
                      <div className="absolute top-0 left-0 w-32 h-32 bg-white rounded-full -translate-x-16 -translate-y-16"></div>
                      <div className="absolute bottom-0 right-0 w-24 h-24 bg-white rounded-full translate-x-12 translate-y-12"></div>
                    </div>
                    <span className="text-8xl">{video.emoji}</span>
                    {/* Play Button Overlay */}
                    <button
                      onClick={() => setPlayingVideo(video.id)}
                      className="absolute inset-0 flex items-center justify-center bg-black/20 hover:bg-black/30 transition-colors cursor-pointer"
                    >
                      <div className="w-20 h-20 rounded-full bg-white/90 flex items-center justify-center shadow-lg hover:scale-110 transition-transform">
                        <Play className="w-10 h-10 text-purple-600 ml-1" />
                      </div>
                    </button>
                  </>
                )}
              </div>

              {/* Video Info */}
              <div className="p-6 bg-white">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-1 text-xs font-semibold bg-purple-100 text-purple-600 rounded-full">
                    {video.duration}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{video.title}</h3>
                <p className="text-gray-600 text-sm mb-4">{video.description}</p>

                {/* Watch Button */}
                <button
                  onClick={() => setPlayingVideo(playingVideo === video.id ? null : video.id)}
                  className="w-full py-4 text-lg font-bold transition-all duration-300 text-white text-center rounded-xl flex items-center justify-center gap-2"
                  style={{
                    background: `linear-gradient(135deg, #a855f7, #ec4899)`,
                  }}
                >
                  <Video className="w-5 h-5" />
                  {playingVideo === video.id ? 'Close Video' : 'Watch Video'}
                </button>
              </div>
            </Card>
          ))}

          {/* Coming Soon Card */}
          <Card
            className="overflow-hidden transition-all duration-300 hover:scale-105 border-2 border-dashed border-purple-300"
            style={{ borderRadius: '24px' }}
          >
            <div className="h-56 bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center">
              <span className="text-6xl opacity-50">🎥</span>
            </div>
            <div className="p-6 bg-white text-center">
              <h3 className="text-xl font-bold text-gray-400 mb-2">More Videos Coming Soon!</h3>
              <p className="text-gray-400">Stay tuned for more fun learning videos...</p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default KidsVideosPage;
